import { render, staticRenderFns } from "./returnCodeHtml.vue?vue&type=template&id=579a2f1c&scoped=true"
import script from "./returnCodeHtml.vue?vue&type=script&lang=js"
export * from "./returnCodeHtml.vue?vue&type=script&lang=js"
import style0 from "./returnCodeHtml.vue?vue&type=style&index=0&id=579a2f1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579a2f1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579a2f1c')) {
      api.createRecord('579a2f1c', component.options)
    } else {
      api.reload('579a2f1c', component.options)
    }
    module.hot.accept("./returnCodeHtml.vue?vue&type=template&id=579a2f1c&scoped=true", function () {
      api.rerender('579a2f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operatingPlatform/returnCodePrinting/component/returnCodeHtml.vue"
export default component.exports